import { onError } from '@apollo/client/link/error';
import hashHistory from '@nile/home/src/hashHistory';

const getCookieValue = (name) =>
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';

const errorLink = onError((params) => {
  const { graphQLErrors, networkError } = params;

  if (graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
  } else if (networkError) {
    switch (networkError?.statusCode) {
      case 568: // ITEM DELETED
        hashHistory.push('/error/itemNotFound', { errors: networkError });
        break;
      default:
      /**
       * arg[1] - String (Error type)
       * arg[2] - String (Error message)
       * arg[3] - String (Language)
       * arg[4] - Object (Message dynamic message fields)
       * arg[5] - String (Toaster id)
       */
      // toast('error', 'app.toast.error.message', 'en', undefined, 'network-default-error');
    }
  } else {
    /**
     * arg[1] - String (Error type)
     * arg[2] - String (Error message)
     * arg[3] - String (Language)
     * arg[4] - String (Message dynamic message fields)
     * arg[5] - String (Toaster id)
     */
    // toast('error', 'app.toast.error.message', 'en', undefined, 'network-default-error');
  }
  //   if (logger) {
  //     logger.info('Network graphql request', {
  //       graphQLErrors,
  //       networkError,
  //       info
  //     });
  //     logger.flush();
  //   }
});

export { errorLink };
